import { Outlet } from "react-router-dom";

export default function JobDescriptionLayout() {
    return(
        <Outlet />
    );
}